export default __webpack_public_path__ + "static/service-1-fbda68dc0b316fcb15a93603bd86d4ed.jpg";